module.exports = __webpack_public_path__ + "img/placeholder-picture-02.658e208c.png";